module.exports = __webpack_public_path__ + "img/logo_header.6731734a.svg";